import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerInterface } from "@/features/InControlPanel/Users/UsersList/Interfaces/PartnerInterface";

export interface CreateTicketByStaffInterface {
    partner: null | PartnerInterface,
    partnerVerified: boolean,
}

function getInitialState() {
    const state: CreateTicketByStaffInterface = {
        partner: null,
        partnerVerified: false,
    };
    return state;
}

export const CreateTicketByStaffSlice = createSlice({
    name: "CreateTicketByStaffSlice",
    initialState: getInitialState(),
    reducers: {
        setPartner: (state: CreateTicketByStaffInterface, action: PayloadAction<CreateTicketByStaffInterface["partner"]>) => {
            state.partner = action.payload;
        },
        changePartnerVerified: (state: CreateTicketByStaffInterface, action: PayloadAction<CreateTicketByStaffInterface["partnerVerified"]>) => {
            state.partnerVerified = action.payload;
        },
        reset: (state: CreateTicketByStaffInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.partner = initialState.partner;
            state.partnerVerified = initialState.partnerVerified;
        },
    },
});

export const {
    setPartner,
    changePartnerVerified,
    reset,
} = CreateTicketByStaffSlice.actions;

export const getSelectorForValue = (name: keyof CreateTicketByStaffInterface) => (state: RootState) => state.createTicketByStaff[name];

export const CreateTicketByStaffReducer = CreateTicketByStaffSlice.reducer;